import React, {
  useContext,
  createContext,
  useMemo,
  useCallback,
  useState,
  useEffect,
} from 'react';
import { default as api } from '~/services/api2';
import { useAuth } from '../AuthContext';

const TablesContext = createContext();

function TablesProvider({ children }) {
  const { token } = useAuth();

  const [tablesAvailable, setTablesAvailable] = useState([]);
  const [tableMenu, setTableMenu] = useState();

  const page = window.location.pathname;
  const getTablesAvailable = useCallback(async () => {
    if (page === '/delivery/orders') {
      return;
    }
    const response = await api.get('/restaurants/tables', {
      params: {
        status: 'available',
      },
    });

    const tablesAvailableFind = response.data.filter(
      (tables) => tables.table_type !== 'menu'
    );
    const tableMenuFind = response.data.filter(
      (tables) => tables.table_type === 'menu'
    );

    setTablesAvailable(tablesAvailableFind);
    setTableMenu(tableMenuFind[0]);
  }, [page]);

  useEffect(() => {
    if (
      page !== '/delivery/orders' && 
      page !== '/fiscal/issued' &&
      page !== '/fiscal/manifest'
    ) {
      getTablesAvailable();
    }
  }, [token, page, getTablesAvailable]);

  const value = useMemo(
    () => ({
      tablesAvailable,
      getTablesAvailable,
      tableMenu,
    }),
    [tablesAvailable, getTablesAvailable, tableMenu]
  );

  return (
    <TablesContext.Provider value={value}>{children}</TablesContext.Provider>
  );
}

function useTables() {
  const context = useContext(TablesContext);

  if (!context) {
    throw new Error('useTables must be used within an OrderProvider');
  }

  return context;
}

export { TablesProvider, useTables };
